/* eslint-disable spaced-comment */
/* eslint-disable arrow-body-style */
/* eslint-disable import/no-unresolved */
/* eslint-disable prettier/prettier */
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { config } from 'src/helpers/config';
import { setCookie } from 'src/helpers/cookies';

export const login = createAsyncThunk(
  //action type string
  'auth/login',
  // callback function
  async (data) => {
    const response = await axios.post(`${config.apiUrl}auth`, {
      email: data.email,
      password: data.password
    });
    console.log(response.data.result.token);
    setCookie('ewangelibus_user', response.data.result.token);

    return response.data.result;
  }
);

export const authSlice = createSlice({
  name: 'auth',
  initialState: {
    user: null
  },
  reducers: {
    _login: (state, action) => {
      axios
        .post(`${config.apiUrl}auth`, {
          email: action.payload.email,
          password: action.payload.password
        })
        .then((e) => {
          console.log('eeeeeeeeeeee');
          console.log(e);
        });
    },
    logout: (state) => {
      state.user = null;
    }
  },
  extraReducers: {
    [login.fulfilled]: (state, { payload }) => {
      console.log(payload);
      state.user = payload;
    }
  }
});

// Action creators are generated for each case reducer function
export const { _login, logout } = authSlice.actions;

export default authSlice.reducer;
